import React, { forwardRef, useCallback, useState } from "react";
import { useTableHeaderCorners } from "./tableHeaderCorners.js";

// Retains native semantics/ref and does nothing to tbody-only sizing tables.
export const CornerTable = forwardRef(function CornerTable(props, forwardedRef) {
  const [table, setTable] = useState(null);
  const ref = useCallback(node => {
    setTable(node);
    if (typeof forwardedRef === "function") forwardedRef(node);
    else if (forwardedRef) forwardedRef.current = node;
  }, [forwardedRef]);
  useTableHeaderCorners(table);
  return <table {...props} ref={ref} />;
});
